import React from 'react'

const MenuItemLanguageChooser = ({ translation}) => {
    const { languages } = translation

    if(!languages) {
        return ''
    }

    const languageKeys = Object.keys(languages)

    if(languageKeys.length < 2) {
        return ''
    }

    return (
        <li className="menu-item menu-item-langchooser">
            <ul>
            {languageKeys.map((key, index) => {
                const lang = languages[key]
                const { current_lang, slug,  url} = lang
                const slugDisplay = slug.toUpperCase()

                if( current_lang) {
                    return (
                        <li key={index} className="menu-item sub-menu-item-active">
                            <span className="text-medium-navigation">
                                <span className="menu-item-link">
                                    <span>{slugDisplay}</span>
                                </span>
                            </span>
                        </li>
                    )
                } else {
                    return (
                        <li key={index} className="menu-item">
                            <a className="text-medium-navigation" href={url}>
                                <span className="menu-item-link">
                                    <span>{slugDisplay}</span>
                                </span>

                            </a>
                        </li>
                    )
                }
            })}
            </ul>
        </li>
    )
}

export default MenuItemLanguageChooser